module.exports = __webpack_public_path__ + "static/media/pet-prod.f0461e62.jpg";